export const DEFAULT_LOCALE = "ja";

export const DEFAULT_PAGE = 1;

export const DEFAULT_PER_PAGE = 10;

// IP制限動作確認用
export const LOCAL_STATIC_IP = "153.246.214.177";

// countries tableの日本のID
export const COUNTRY_JAPAN_ID = "109";

// price_registration_sourceの一覧表示の件数
export const PRICE_REGISTRATION_SOURCE_PER_PAGE = 200;

// Global Menuの高さ
export const AppBarHeight = 64;

// Global Menuの左に出るDrawerの幅
export const DrawerWidth = 260;
// SSR実行環境が自分自身のAPI Routeを叩くループバック先。
// VercelのSSR実行環境（AWS内部）の内部DNSリゾルバはpublicドメイン(NEXT_PUBLIC_FRONTEND_API_BASE_URL)の
// 委任変更に追随しないことがあるため、Vercelが管理するデプロイ固有ドメイン(VERCEL_URL)があればそちらを優先する。
export const SSR_LOOPBACK_BASE_URL = process.env.VERCEL_URL
  ? `https://${process.env.VERCEL_URL}`
  : process.env.NEXT_PUBLIC_FRONTEND_API_BASE_URL;

// 日本円のcurrency定義
// TODO: id指定ではなくcode指定に修正する
export const YEN = {
  id: "392",
  displayName: "JPY",
  currencyCode: "円",
};
